import styled from 'styled-components'

export const Container = styled.div`
  display: flex;
  align-items: center;
  gap: ${props => props.theme.spacing.sp16};

  #draggable-icon {
    cursor: grab;
    flex-shrink: 0;
  }

  & > div {
    flex-grow: 1;
  }
`
